module.exports = __webpack_public_path__ + "img/1.9453d24f.svg";